import { FC, Fragment, ReactNode } from 'react';
import * as Styles from './page-layout.module.less';

interface PageLayoutProps {
    header?: ReactNode;
    content: ReactNode;
}

export const PageLayout: FC<PageLayoutProps> = ({ content, header }) => {
    return (
        <Fragment>
            {header && (
                <div className={Styles.pageLayoutHeader}>
                    <div className={Styles.pageLayoutHeaderContent}>{header}</div>
                </div>
            )}
            <div className={Styles.pageLayout}>
                <div className={Styles.pageLayoutContent}>{content}</div>
            </div>
        </Fragment>
    );
};
